import PropTypes from 'prop-types';

import withTopic from 'core/hocs/withTopic';

export default function skipRenderWithSharingDisabled(Component) {
  function SocialConsumer(props) {
    const { topic,
      ...otherProps
    } = props;

    if (topic && topic.content && Boolean(topic.content.attributes.is_sharing_disabled)) {
      return null;
    }

    return <Component {...otherProps} />;
  }

  SocialConsumer.propTypes = {
    topic: PropTypes.object,
  };

  return withTopic(SocialConsumer);
}


